import React from 'react';
import './JobNotification.css';

const JobNotification = ({ message, jobId, onClose, onViewJobs }) => {
  return (
    <div className="job-notification-overlay">
      <div className="job-notification-modal">
        <div className="notification-icon">✅</div>
        <h2>Report Generation Started</h2>
        <p className="notification-message">{message}</p>
        
        {jobId && (
          <div className="job-id-info">
            <span className="label">Job ID:</span>
            <code className="job-id">{jobId}</code>
          </div>
        )}
        
        <p className="notification-hint">
          Your report is being generated in the background. 
          This may take a few minutes depending on the complexity.
        </p>
        
        <div className="notification-actions">
          <button 
            className="btn-view-jobs"
            onClick={onViewJobs}
          >
            📋 View Jobs Tab
          </button>
          <button 
            className="btn-close"
            onClick={onClose}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobNotification;
